import VueRouter from 'vue-router'
import queryString from 'query-string'
import routes from '@/routes'
import { useConfigStore, useUserStore } from '@/stores'
import '@/ployfills'
import { $isLogin } from '@/helpers'
import { ERROR_PAGE_LEVEL } from '@/constants'
import { generateOAuthUrl } from '@/kuaishou'
import { track } from '@/track'

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(_to, _from, _savedPosition) {
    return { x: 0, y: 0, behavior: 'smooth' }
  },
})

// Router Guards
router.beforeEach(async (to, form, next) => {
  // Set document title
  document.title = to?.meta?.title

  const configStore = useConfigStore()
  const userStore = useUserStore()

  if (to.meta?.requiresAuth === false) {
    next()
  }
  else if (to.meta?.requiresAuth !== false && !$isLogin()) {
    const redirect = `${window.location.origin}/authorize?${queryString.stringify({
      redirect: to.fullPath,
    })}`
    const oAuthURL = generateOAuthUrl({
      redirect,
      appId: import.meta.env.VITE_KUAISHOU_APP_ID,
    })
    window.location.replace(oAuthURL)
  }
  else {
    try {
      // Note: Fetch global config
      await configStore.init()
      await userStore.init()
      next()
    }
    catch (error: any) {
      next({
        name: 'error',
        query: {
          level: ERROR_PAGE_LEVEL.FATAL,
          message: error.msg || error.message,
          redirect: window.encodeURIComponent(window.location.href),
        },
        replace: true,
      })
    }
  }
})

// Tracking
router.afterEach((to, from) => {
  const params: Record<string, any> = {
    fromUrl: from.fullPath,
    fromTitle: from.meta?.title ?? '',
    toUrl: to.fullPath,
    toTitle: to.meta?.title ?? '',
  }
  if (to.name === 'chapter') {
    params.contentId = to.params.contentId
    params.chapterId = to.params.chapterId
  }

  if (to.name === 'chapter' && to.params.chapterId === '0')
    return

  track('pageView', params)
})

export default router
